import { initItemPage } from 'src/lib/item-page.js'
import 'src/styles/correspondence.css'

initItemPage()
